module.exports = __webpack_public_path__ + "static/img/home_logo_002.112b5492.png";